import type { PaginationOptions } from 'swiper/types';
import { Children, FC, memo, useMemo, ReactNode } from 'react';
import { Swiper as SwiperLib, SwiperProps, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import type { IRefsSwiper } from './types';
import useSwiper from './useSwiper';

interface ISwiper extends SwiperProps {
  refs?: Partial<IRefsSwiper>;
  pagination?: Partial<PaginationOptions>;
  children: ReactNode;
}

const CSwiper: FC<ISwiper> = ({ children, refs = {}, pagination, ...other }) => {
  const { isInit, navigationOptions, paginationOptions } = useSwiper(refs);

  const wrappedChildren = useMemo(
    () =>
      Children.map(
        children,
        (child, index) =>
          // eslint-disable-next-line react/no-array-index-key
          child && <SwiperSlide key={index}>{child}</SwiperSlide>,
      ),
    [children],
  );

  return (
    <SwiperLib
      init={isInit}
      navigation={navigationOptions}
      pagination={{ ...pagination, ...(paginationOptions || {}) }}
      {...other}
    >
      {wrappedChildren}
    </SwiperLib>
  );
};

const MemoSwiper = memo(CSwiper);

export default MemoSwiper;
